import baseAPI from "@/api/base";
import { EditCallLog, GetCallLog, RegisterCallLog } from "@/dtos/CallLog.dto";
import {
  DELETE_CALL_LOG_URL,
  GET_CALL_LOG_URL,
  LOG_CALL_LOG_DETAILS_URL,
  REGISTER_CALL_LOG_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class CallLog {
  static getCallLogs = async (getCallLog: GetCallLog): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_CALL_LOG_URL, {
      params: getCallLog,
    });
    return response;
  };

  static registerCallLog = async (registerCallLog: RegisterCallLog): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_CALL_LOG_URL, {
      ...registerCallLog,
    });
    return response;
  };

  static logCallLogDetails = async (editCallLog: EditCallLog): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(LOG_CALL_LOG_DETAILS_URL, {
      ...editCallLog,
    });

    return response;
  };

  static deleteCallLog = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_CALL_LOG_URL}/${id}`);
    return response;
  };

  static regenerateAnalysis = async (callLogId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      `${GET_CALL_LOG_URL}/${callLogId}/regenerate-analysis`
    );
    return response;
  };
}

export default CallLog;
